<!--
  @Description 模块菜单导入
  @Date 2021-12-26
  @Author liushuo
  1.导入数据，不包括问题说明
  2.导入后主表点击保存
  3.保存后才可以批量输入问题说明（保存后才有id）
-->
<template>
  <vxe-modal
    v-model="isShow"
    title="模块菜单导入"
    width="80%"
    height="80%"
    @show="showWindows"
    mask-closable
    destroy-on-close
  >
    <vxe-toolbar>
      <template v-slot:buttons>
        <div>
          <input
            type="file"
            ref="uploadExcel"
            v-show="false"
            id="open"
            accept=".xls, .xlsx"
            @change="readExcel"
            v-if="resetExcel"
          />
          <el-input
            v-model="path"
            readonly
            size="mini"
            class="path-box"
          ></el-input>
          <el-button @click="importExcel" type="primary" size="mini"
            >选择文件</el-button
          >
          <el-button @click="handleSave" type="primary" size="mini"
            >确认</el-button
          >
          <el-button @click="exportModule" type="primary" size="mini"
            >导出模板</el-button
          >
        </div>
        <span>
          导入格式为： 模块、页面、前端研发、后端研发、技术测试、业务测试、说明
        </span>
        <br />
      </template>
    </vxe-toolbar>
    <div class="grid-box">
      <vxe-grid
        ref="xTable"
        highlight-hover-row
        highlight-current-row
        :data="tableData"
        keep-source
        resizable
        size="mini"
        :column-config="{ minWidth: '80px' }"
        :height="tableHeight"
        :cell-class-name="cellClassName"
        :edit-rules="validRules"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          activeMethod: activeMethod,
        }"
        :keyboard-config="{
          isArrow: true,
          isEnter: true,
          isTab: true,
          enterToTab: true,
          isClip: true,
          isEdit: true,
          editMethod: editMethod,
        }"
        :columns="gridColumns"
      >
      </vxe-grid>
    </div>
  </vxe-modal>
</template>

<script>
export default {
  props: {
    parentObj: Object
  },
  data() {
    return {
      // 列头
      gridColumns: [],
      // 是否显示
      isShow: false,
      menuArgs: '',
      tableData: [],
      // 验证规则
      validRules: {},
      // 验证错误
      errIndex: [],
      path: '',
      resetExcel: true,
      // 区域数据
      areaList: [],
      // 人员列表
      EmployeeList: []
    }
  },
  created() {
    this.InitRules()
    this.InitColumn()
  },
  mounted() { },
  methods: {
    // 初始化校验规则
    InitRules() {
      this.validRules = {
        groupName: [
          { required: true, message: '请输入模块名', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '模块名长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        vuePath: [
          { required: true, message: '请输入页面名', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '页面名长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        frontEngineer: [
          {
            min: 0,
            max: 5,
            message: '前端研发长度应在 0 到 5 个字符',
            trigger: 'change'
          },
          { validator: this.validEmployee, trigger: 'change' }
        ],
        backEngineer: [
          {
            min: 0,
            max: 5,
            message: '后端研发长度应在 0 到 5 个字符',
            trigger: 'change'
          },
          { validator: this.validEmployee, trigger: 'change' }
        ],
        techTester: [
          {
            min: 0,
            max: 5,
            message: '技术测试长度应在 0 到 5 个字符',
            trigger: 'change'
          },
          { validator: this.validEmployee, trigger: 'change' }
        ],
        businessTester: [
          {
            min: 0,
            max: 5,
            message: '业务测试长度应在 0 到 5 个字符',
            trigger: 'change'
          },
          { validator: this.validEmployee, trigger: 'change' }
        ],
      }
    },
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [<el-tooltip class="tooltipItem"
                  effect="light" content={row.repeatText} placement="right" >
                  <div style="width: 100%; height: 100%">
                    <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                  </div>
                </el-tooltip>]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        { field: 'delete', title: '删除', width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.handleCellDelete(row) }} ></i>] } } },
        {
          title: '模块',
          field: 'groupName',
          editRender: { name: 'input' }
        },
        {
          title: '页面',
          field: 'vuePath',
          editRender: { name: 'input' }
        },
        {
          title: '前端研发',
          field: 'frontEngineer',
          editRender: { name: 'input' }
        },
        {
          title: '后端研发',
          field: 'backEngineer',
          editRender: { name: 'input' }
        },
        {
          title: '技术测试',
          field: 'techTester',
          editRender: { name: 'input' }
        },
        {
          title: '业务测试',
          field: 'businessTester',
          editRender: { name: 'input' }
        },
        {
          title: '说明',
          field: 'dMemo',
          editRender: { name: 'input' }
        }
      ]
    },
    showWindows() {
      // 清空表格数据
      this.tableData = []
      // 清空文件名
      this.path = ''
      this.BindComBox()
    },
    // 删除行
    handleCellDelete(row) {
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.xTable.remove(row)
          this.IfExistModify = true
        })
        .catch(() => { })
    },
    // 绑定下拉框
    async BindComBox() {
      this.EmployeeList = []
      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        this.EmployeeList.push(item.name)
      }
    },
    // 验证
    async validEnter() {
      let that = this
      let flag = true
      this.errIndex = []
      // 重复行
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['groupName', 'vuePath'])
      if (this.errIndex.length > 0) {
        flag = false
      }
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              that.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
      }
      if (that.errIndex.length > 0) {
        flag = false
      }
      if (!flag) {
        that.$message.error('验证失败,请核对数据')
      }
      return flag
    },
    validEmployee({ cellValue }) {
      if (cellValue && !this.EmployeeList.includes(cellValue)) {
        return new Error('用户当中不存在该人员！')
      }
    },
    // 转换字符串
    transString(str) {
      if (str) {
        return str + ''
      }
    },
    importExcel() {
      this.resetExcel = false
      this.$nextTick(() => {
        this.resetExcel = true
      })
      this.$refs.uploadExcel.click()
    },
    // 导入excel
    readExcel(evnt) {
      let files = evnt.target.files
      if (files.length === 0) {
        return
      }
      this.path = files[0].name
      let fileReader = new FileReader()
      fileReader.onload = ev => {
        let data = ev.target.result
        let workbook = this.XLSX.read(data, { type: 'binary' })
        // 取第一张表
        const wsname = workbook.SheetNames[0]
        let ws = this.XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
        let str = JSON.stringify(ws)
        str = str.replace(/（/g, '(')
        str = str.replace(/）/g, ')')
        ws = JSON.parse(str)

        this.tableData = []
        // 解析数据
        ws.forEach((value, index, ws) => {
          this.tableData.push({
            groupName: this.transString(ws[index]['模块']),
            vuePath: this.transString(ws[index]['页面']),
            frontEngineer: this.transString(ws[index]['前端研发']),
            backEngineer: this.transString(ws[index]['后端研发']),
            techTester: this.transString(ws[index]['技术测试']),
            businessTester: this.transString(ws[index]['业务测试']),
            dMemo: this.transString(ws[index]['说明'])
          })
        })
      }
      fileReader.readAsBinaryString(files[0])
    },
    // 确认值
    async handleSave() {
      const that = this
      this.validEnter().then(async result => {
        if (result) {
          let tableData = this.$refs.xTable.getTableData().fullData
          tableData = that.removeArrayNull(tableData)
          that.$emit('sureImportBack', tableData)
          that.$nextTick(() => {
            that.isShow = false
          })
        }
      })
    },
    // cell激活控制
    activeMethod() {
      return true
    },
    // cell编辑控制
    editMethod() {
      return true
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // 导出模板
    exportModule() {
      this.$refs.xTable.exportData({
        type: 'xlsx',
        // 过滤序号列
        columnFilterMethod: ({ column }) => {
          if (column.type === 'seq') {
            return false
          }
          return true
        }
      })
    }
  },
  computed: {
    tableHeight() {
      if (this.isShow) {
        return this.$store.state.clientHeight * 0.8 - 170 + 'px'
      } else {
        return '100px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.path-box {
  width: 50%;
  margin-right: 20px;
}
.vxe-toolbar {
  display: flex;
  align-items: flex-start;
  height: 90px;
}
</style>
